import { CategoryOrderBy } from '@carto/api-client'

export type SqlParameterItem<ValueType = string> = {
  sqlName: string
  value: ValueType
}

export enum SqlParameterType {
  DateRange = 'DateRange',
  Category = 'Category',
  Numeric = 'Numeric',
  NumericRange = 'NumericRange'
}

export type SqlBaseParameter = {
  id: string
  name: string
  type: SqlParameterType
}

export type SqlDateRangeParameter = SqlBaseParameter & {
  type: SqlParameterType.DateRange

  // start and end values are in ISO-8601 date format, i.e YYYY-MM-DD regardless of how they are presented
  // to user and/or sent to SQL
  start: SqlParameterItem<string>
  end: SqlParameterItem<string>

  // @deprecated We let the user introduce any Date without restrictions
  allowedRange?: [string, string]
}

export type SqlCategoryParameter = SqlBaseParameter & {
  type: SqlParameterType.Category
  item: SqlParameterItem<string[]>
  values: string[]
  orderBy?: CategoryOrderBy
}

export type NumericParameterCommon = {
  min: number
  max: number
  step?: number
}
export type SqlNumericParameter = SqlBaseParameter &
  NumericParameterCommon & {
    type: SqlParameterType.Numeric
    item: SqlParameterItem<number>
    defaultValue: number
  }

export type SqlNumericRangeParameter = SqlBaseParameter &
  NumericParameterCommon & {
    type: SqlParameterType.NumericRange
    start: SqlParameterItem<number>
    end: SqlParameterItem<number>
  }

export type SqlParameter = SqlDateRangeParameter | SqlCategoryParameter | SqlNumericParameter | SqlNumericRangeParameter
